export const EIGHTEEN_YEARS_IN_MILLISECONDS = 568036800000;

export const MILLISECONDS_PER_SECOND = 1000;

export const SECONDS_PER_MINUTE = 60;

export const MINUTE = SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND;

export const DAY = MINUTE * 60 * 24;

export const WEEK_DAYS = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];
